
<template>
  <div>
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/mobiscope/imgs/planet-right.png"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{ $t("hello") }}</h1>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
         
            
            <div class="d2-section ">
              <div class="d2-section __content">
               <div class="formElm">
                 <div class="btnContainer " v-if="auth_mobis === 'loggedin'">
                     
                    <div v-if="is_unsub_mobis != '0'">
                        <div v-if="gcid_mobis == '314'">
                       <a  class="btn btn-lg stdBtn" data-toggle="modal" data-target="#exampleModalCenter">
                          {{ $t("unsubscribe") }}
                        </a>
                        </div>
                        <div v-else>
                           <a @click="logout_mobis(is_unsub_mobis)" href="" class="btn btn-lg stdBtn">{{ $t("unsubscribe") }}</a>
                        </div>
                     
                    </div>
                    <div v-else>
                      <a @click="logout_mobis(is_unsub_mobis)"  href="/logout" class="btn btn-lg stdBtn">{{ $t("unsubscribe") }}</a>
                    </div>
                  </div>
             
            </div>
        </div>
      </div>
    </div>
    
  </div>
  </div></div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "gcid_mobis",
    "auth_mobis",
    "is_unsub_mobis"
  ]),
  methods: {
    ...mapActions(["logout_mobis",])
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/Profile.vue